import httpManager from "@/app/shared/utils/httpManager";

export async function fetchCallsWaitingByQueue(queueId) {
  const url = `/queues/${queueId}/inbounds/`;
  const response = await httpManager.get(url);
  return response.data?.inbounds;
}
